<template>
  <div ref="messageHistory">
    <v-card v-if="user.mainType == 0" class="pa-3 mb-2" color="#f5f5f5" flat>
      <div class="d-flex align-center">
        <v-btn icon text small class="mr-1" @click="$emit('back')">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <div>
          <strong class="secondary--text">
            {{ chat.user ? chat.user.name : 'Usuário indefinido' }}
          </strong>
          <br />
          {{
            chat.user && chat.user.institutions && chat.user.institutions[0]
              ? offices[chat.user ? chat.user.institutions[0].userOffice : '']
              : 'Indefinido'
          }}
          em
          <span> </span>
        </div>
      </div>
    </v-card>

    <v-file-input
      id="image-picker"
      accept="image/png, image/jpeg, image/bmp,, image/jpg, image/svg"
      class="d-none"
      multiple
      @change="setImages"
    ></v-file-input>

    <div id="messages">
      <v-card
        v-if="messages.length == 0"
        flat
        class="d-flex justify-center align-center ma-2 pa-4 primary white--text"
        style="min-height: 100%"
      >
        <div>
          <strong> Bem vindo ao chat de suporte! </strong>
          <br />

          Aqui você pode tirar dúvidas e reportar problemas relacionados ao
          software!
        </div>
      </v-card>

      <div v-else>
        <v-card
          v-if="showIntersecCard && pager.totalPages > 1"
          v-intersect="getMoreMessages"
        >
        </v-card>

        <div v-for="(message, index) in messages" :key="index">
          <div
            v-if="
              checkDate(message, messages[index - 1]) ||
              messages[index - 1] == null
            "
            class="d-flex justify-center my-1"
          >
            <v-chip class="date-chip">
              {{ getChatDate(message.createdAt) }}
            </v-chip>
          </div>

          <RightMessage v-if="message.senderId == user.id" :message="message" />
          <LeftMessage v-else :message="message" />
        </div>
      </div>
    </div>

    <v-expand-transition v-if="images != null && images.length > 0">
      <div
        style="position: absolute; width: 100%; bottom: 83px"
        :style="
          images.length > 1
            ? 'max-height: 240px;overflow-y: auto;background: #e5e5e5; border-radius: 10px'
            : ''
        "
      >
        <div
          v-for="(item, index) in images"
          :key="index"
          style="position: relative"
        >
          <div
            v-if="images.length == 1"
            class="pa-4 ma-2"
            style="background: #e5e5e5; border-radius: 6px"
          >
            <div class="d-flex justify-end">
              <v-btn small icon @click="images.splice(index, 1)" text>
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>
            <div class="d-flex justify-center">
              <v-img
                :src="item.picPath"
                height="120px"
                max-height="80px"
                style="border-radius: 10px"
              ></v-img>
            </div>
          </div>
        </div>
      </div>
    </v-expand-transition>

    <v-form ref="form">
      <v-textarea
        v-model="message"
        :rules="[(v) => !!v || 'Insira a mensagem']"
        placeholder="Digite sua mensagem aqui"
        background-color="white"
        outlined
        no-resize
        style="box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25); border-radius: 5px"
        hide-details
        rows="3"
        @submit.prevent=""
      >
        <template #prepend-inner>
          <v-menu v-model="menu" top offset-y :close-on-content-click="false">
            <template #activator="{ on, attrs }">
              <v-icon class="mr-2 emoji-icon" v-bind="attrs" v-on="on">
                mdi-emoticon-happy-outline
              </v-icon>
            </template>

            <VEmojiPicker @select="sendEmoji" />
          </v-menu>
        </template>

        <template #append>
          <v-btn
            elevation="0"
            fab
            class="ml-4"
            x-small
            text
            @click="openPicker"
          >
            <v-icon color="#666">mdi-camera</v-icon>
          </v-btn>

          <v-btn
            elevation="0"
            fab
            color="primary"
            class="ml-4"
            x-small
            :loading="loading"
            @click="send"
          >
            <v-icon x-small color="#F9F9F9">mdi-send-outline</v-icon>
          </v-btn>
        </template>
      </v-textarea>
    </v-form>
  </div>
</template>

<style scoped>
.date-chip {
  width: min-content;
  background: #0f3565 !important;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 18px;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  color: #f9f9f9;
}

#messages {
  overflow-y: auto;
  height: unset;
  min-height: 54vh;
  max-height: 57vh;
  scroll-snap-type: y proximity;
}

#messages::-webkit-scrollbar {
  width: 8px;
  border-radius: 6px;
}

#messages::-webkit-scrollbar-thumb {
  width: 8px;
  border-radius: 6px;
}
</style>

<script>
import ApiService from '../../services/ApiService'
import LeftMessage from './leftMessage.vue'
import RightMessage from './rightMessage.vue'
import moment from 'moment'

export default {
  name: 'ChatMessagesComponent',

  props: {
    chat: Object,
  },

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    if (this.chat.id) {
      this.localChatId = this.chat.id
      this.getMessages()
    } else await this.addChat()

    this.addSocket()
    await this.visualize()
  },

  beforeDestroy() {
    if (this.socket) {
      this.socket.close()
    }
  },

  destroy() {
    if (this.socket) {
      this.socket.close()
    }
  },

  components: {
    LeftMessage,
    RightMessage,
  },

  data() {
    return {
      offices: [
        'Auxiliar',
        'Coordenador',
        'Enfermeiro',
        'Engenheiro',
        'Estagiário',
        'Recepcionista',
        'Supervisor',
        'Técnico',
        'Farmacêutico',
        'Fisioterapeuta',
        'Administrativo',
        'Gerente',
        'Nutricionista',
      ],
      localChatId: '',
      showIntersecCard: false,
      images: [],
      socket: null,
      user: {},
      messages: [],
      loading: false,
      fab: false,
      menu: false,
      message: '',
      apiService: new ApiService(),
      pager: {},
      page: 1,
    }
  },

  methods: {
    async visualize() {
      await this.apiService.post(`chat/visualize/${this.localChatId}`)
    },
    async addChat() {
      this.loading = true
      await this.apiService
        .post('chat')
        .then((response) => {
          this.localChatId = response.content
          this.getMessages()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    getMoreMessages(entries, observer) {
      if (entries[0].isIntersecting) {
        this.page++

        if (this.page <= this.pager.endPage) {
          const initialHeight = this.$refs.messageHistory.scrollHeight

          this.loading = true

          this.apiService
            .get(`chat`, {
              chatId: this.localChatId,
              userId:
                this.user.mainType == 0 ? this.chat.senderId : this.user.id,
              page: this.page,
              pageSize: 30,
            })
            .then((response) => {
              this.messages.unshift(...response.content.data.reverse())
              this.pager = response.content.pager
              this.showIntersecCard = false

              this.$nextTick(() => {
                this.$refs.messageHistory.scrollTop =
                  this.$refs.messageHistory.scrollHeight - initialHeight
              })

              this.loading = false
              setTimeout(() => {
                this.showIntersecCard = true
              }, 5000)
            })
            .catch(() => {
              this.loading = false
            })
        }
      }
    },

    getMessages() {
      this.loading = true
      this.apiService
        .get(`chat`, {
          chatId: this.localChatId ?? null,
          userId: this.user.mainType == 0 ? this.chat.senderId : this.user.id,
          page: 1,
          pageSize: 30,
        })
        .then((response) => {
          this.messages = response.content.data.reverse()
          this.pager = response.content.pager
          this.loading = false

          setTimeout(() => {
            const element = document.getElementById('messages')
            if (element) {
              element.scrollTop = element.scrollHeight
            }
          }, 50)

          setTimeout(() => {
            this.showIntersecCard = true
          }, 5000)
        })
        .catch(() => {
          this.loading = false
        })
    },

    getChatDate(date) {
      if (date) {
        if (
          moment(date).format('DD/MM/yyyy') ===
          moment(new Date()).format('DD/MM/yyyy')
        ) {
          return 'Hoje'
        }

        return moment(date).locale(this.$i18n.locale).format('DD/MM/yyyy')
      }

      return date
    },

    checkDate(message, lastMesssage) {
      if (message && lastMesssage) {
        return (
          moment(message.createdAt).format('DD/MM/yyyy') !==
          moment(lastMesssage.createdAt).format('DD/MM/yyyy')
        )
      }
    },

    addSocket() {
      if (this.socket) this.socket.close()

      this.socket = new WebSocket(
        `${process.env.VUE_APP_BASE_URL_SOCKET}?chatId=${this.localChatId}&userId=${this.user.id}`
      )

      const $context = this

      this.socket.onmessage = async function (e) {
        const socketMessage = await JSON.parse(e.data)

        if (socketMessage.entity) {
          $context.messages.push(socketMessage.entity)
          setTimeout(() => {
            const element = document.getElementById('messages')
            element.scrollTop = element.scrollHeight
          }, 100)

          if (socketMessage.entity.senderId != $context.user.id)
            await $context.visualize()
        }

        if (socketMessage.visualized) {
          $context.messages = $context.messages.map((x) => {
            if (x.dateRead) return x
            else
              return {
                ...x,
                dateRead: socketMessage.dateRead,
              }
          })
        }
      }
    },

    openPicker() {
      document.getElementById('image-picker').click()
    },

    setImages(images) {
      const find = images.find((x) => x.size > 2000000)

      if (find) {
        this.$toast.error('Só permitimos upload de imagens até 2mb!')
        return
      }

      images.forEach((image) => {
        const reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = (readerEvt) => {
          this.images.push({
            picName: image.name.split('.')[0],
            picPath: readerEvt.target.result,
            // picPath: `data:${image.type};base64,${readerEvt.target.result}`,
            picExtension:
              image.name.split('.')[image.name.split('.').length - 1],
          })
        }
        reader.onerror = () => this.$toast.error('Ocorreu um erro!')
      })
    },

    sendText() {
      if (this.$refs.form.validate()) {
        this.loading = true

        this.apiService
          .post(
            'chat/message',
            {
              chatId: this.localChatId,
              senderId: this.user.id,
              content: this.message ? this.message : '',
              type: 0,
            },
            null,
            true,
            false
          )
          .then(() => {
            this.$refs.form.reset()
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },

    sendImage() {
      this.images.forEach((item) => {
        let _message = ''

        if (this.message) _message = this.message
        else if (item.picName && !this.message) _message = item.picName

        this.loading = true
        this.apiService
          .post(
            'chat/message',
            {
              chatId: this.localChatId,
              senderId: this.user.id,
              content: _message,
              picName: item.picName,
              picPath: item.picPath,
              picExtension: item.picExtension,
              type: 2,
            },
            null,
            true,
            false
          )
          .then(() => {
            if (this.images.length > 0) this.images.splice(0, 1)
            this.$refs.form.reset()
            this.loading = false
          })
          .catch(() => {
            this.$toast.error(
              `Ocorreu um erro ao tentar enviar o arquivo "${item.picName}"`
            )
            if (this.images.length > 0) this.images.splice(0, 1)
            this.loading = false
          })
      })
    },

    send() {
      if (this.images != null && this.images.length > 0) {
        this.sendImage()
        return
      }
      this.sendText()
    },

    sendEmoji(emoji) {
      this.message = this.message ? this.message + emoji.data : emoji.data
    },
  },
}
</script>
